<template>
  <div
    class="privacy-protect-concept-main"
    :class="{ 'privacy-protect-concept-main-mobile': isMobile }"
  >
    <Base-title class="animate__animated" title="算法透明度"></Base-title>
    <PrivacyProtectConceptContentItem :src="src"></PrivacyProtectConceptContentItem>
  </div>
</template>
<script>
export default {
  // 贝壳隐私保护理念
  name: "PrivacyProtectConcept",
  props: {
    animated: {
      type: String,
      default: "animate__zoomIn",
    },
    src: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.privacy-protect-concept-main {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 70px;
  /* height: 100%; */
  flex-direction: column;
  background-color: #f6faff;
}
.privacy-protect-concept-main-mobile {
  padding-top: 2.1rem;
  padding-bottom: 2.2rem;
}
</style>
